<ng-container *transloco="let t; prefix: 'nav-header'">
  @if (navService.navbarVisibleSignal()) {
    @let user = currentUser();

    <nav class="navbar navbar-expand-md navbar-dark fixed-top">
      <div class="container-fluid">
        <a class="visually-hidden-focusable focus-visible" href="javascript:void(0);" (click)="moveFocus()">{{t('skip-alt')}}</a>

        @if (navService.sideNavVisibilitySignal()) {
          <a class="side-nav-toggle" (click)="toggleSideNav($event)"><i class="fas fa-bars" aria-hidden="true"></i></a>
        }

        <a class="navbar-brand dark-exempt" routerLink="/home" routerLinkActive="active">
          <app-image width="24px" height="24px" imageUrl="assets/images/logo-32.png" classes="logo-icon" />
          <div class="d-none d-md-inline logo">
            <span>Kavita</span>
          </div>
        </a>
        <ul class="navbar-nav col me-auto">
          @if (user) {
            <div class="nav-item search">
              <div class="ng-autocomplete">
                <app-search-typeahead />
              </div>
            </div>
          }
        </ul>

        @if (user) {

          <app-download-queue-widget />

          @if (accountService.hasAdminRole()) {
            <div class="nav-item">
              <app-nav-events-toggle [user]="user" />
            </div>
          }

          @if(breakpointService.isMobileOrBelow()) {
            <button class="btn btn-outline-secondary primary-text" (click)="openLinkSelectionMenu()">
              <app-profile-icon [userId]="user.id" [size]="20" />
            </button>
          } @else {
            <div class="nav-item not-xs-only">
              <a routerLink="/settings" [fragment]="SettingsTabId.Preferences" class="dark-exempt btn btn-icon" [title]="t('settings')">
                <i class="fa fa-cogs nav" aria-hidden="true"></i>
                <span class="visually-hidden">{{t('settings')}}</span>
              </a>
            </div>

            <div ngbDropdown class="nav-item dropdown d-sm-none d-md-block" display="dynamic" placement="bottom-right">
              <button class="btn btn-outline-secondary primary-text" ngbDropdownToggle>
                <span class="phone-hidden d-xs-inline-block d-sm-inline-block me-2">
                  <app-profile-icon [userId]="user.id" [size]="20" />
                </span>
                <span class="d-none d-xs-none d-sm-none d-md-inline-block fw-bold">{{user.username | sentenceCase}}</span>
              </button>
              <div ngbDropdownMenu>
                <a ngbDropdownItem [routerLink]="profileLink()" [fragment]="'stats-tab'">{{t('my-profile')}}</a>
                @for (navItem of navService.navItems; track $index) {
                  @if (navItem.routerLink) {
                    <a ngbDropdownItem [routerLink]="navItem.routerLink" [fragment]="navItem.fragment">{{t(navItem.transLocoKey)}}</a>
                  } @else if (navItem.href) {
                    <a ngbDropdownItem [href]="navItem.href" rel="noopener noreferrer" target="_blank">{{t(navItem.transLocoKey)}}</a>
                  } @else if (navItem.click) {
                    <a ngbDropdownItem (click)="navItem.click()">{{t(navItem.transLocoKey)}}</a>
                  }
                }
              </div>
            </div>
          }
        }
      </div>
    </nav>
  }


</ng-container>
